import './LoginWeb2.css';
import './SocialAuth.css';
import { Button } from '../../ui';
import { useLoginWeb2 } from '../../../hooks';
import { Link } from 'react-router-dom';
import { getLinkWithParams } from '../../../utils';

export function LoginWeb2() {
   const { submitLogin, isLoading, loginForm, setIsLoginModalOpen, signInWithGoogle, isGoogleReady, signInWithApple, isAppleReady } = useLoginWeb2();

   return (
      <div className="signup-container flex flex-col gap-2">
         <div className="flex justify-center items-center gap-2">
            {/* <img
               src="/assets/icons/email-icon.svg"
               alt=""
               width={25}
            /> */}
            <h3>By Email</h3>
         </div>

         <form
            onSubmit={loginForm.handleSubmit(submitLogin)}
            className="signup-form flex flex-col gap-3">
            <div className="flex flex-col gap-2">
               <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                     type="email"
                     id="email"
                     {...loginForm.register('email')}
                     className={loginForm.formState.errors.email ? 'error-input' : ''}
                  />
                  {loginForm.formState.errors.email && <p className="error-message">{loginForm.formState.errors.email.message as string}</p>}
               </div>

               <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <input
                     type="password"
                     id="password"
                     {...loginForm.register('password')}
                     className={loginForm.formState.errors.password ? 'error-input' : ''}
                  />
                  {loginForm.formState.errors.password && <p className="error-message">{loginForm.formState.errors.password.message as string}</p>}
               </div>
               <div className="flex justify-center">
                  <p>
                     <Link
                        className="green"
                        onClick={(e) => {
                           e.stopPropagation();
                           setIsLoginModalOpen(false);
                        }}
                        to={getLinkWithParams('/forgot-password')}>
                        Forgot Password?
                     </Link>
                  </p>
               </div>
            </div>

            <div className="flex flex-col gap-2">
               <Button
                  title="Login"
                  buttonType="submit"
                  type="white-big"
                  className="submit-button"
                  disabled={!loginForm.formState.isValid} // Button is disabled when the form is invalid
                  loading={isLoading}
               />

               <div className="flex justify-center">
                  <p className="grey">
                     No account yet?{' '}
                     <Link
                        className="green"
                        onClick={(e) => {
                           e.stopPropagation();
                           setIsLoginModalOpen(false);
                        }}
                        to={getLinkWithParams('/signup')}>
                        Create Account
                     </Link>
                  </p>
               </div>
            </div>
         </form>

         {(isGoogleReady || isAppleReady) && (
            <div className="social-auth-section">
               <div className="social-auth-divider">
                  <span>Or continue with</span>
               </div>
               {isGoogleReady && (
                  <div className="social-auth-btn-wrap">
                     <button
                        type="button"
                        className="apple-signin-button"
                        onClick={signInWithGoogle}>
                        Sign in with Google
                     </button>
                  </div>
               )}
               {isAppleReady && (
                  <div className="social-auth-btn-wrap">
                     <button
                        type="button"
                        className="apple-signin-button"
                        onClick={signInWithApple}>
                        Sign in with Apple
                     </button>
                  </div>
               )}
            </div>
         )}
      </div>
   );
}
